import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 p-fluid p-jc-center" }
const _hoisted_2 = { class: "p-col-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_target_definition_form = _resolveComponent("target-definition-form")
  const _component_apply_target_card = _resolveComponent("apply-target-card")
  const _component_add_kpi_dialog = _resolveComponent("add-kpi-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0" }, {
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "kn-button p-button-text p-button-rounded",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.saveTemplate
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button p-button-text p-button-rounded",
          icon: "pi pi-times",
          onClick: _ctx.closeTemplate
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_target_definition_form, {
          selectedTarget: _ctx.target,
          categories: _ctx.categories,
          onValueChanged: _ctx.updateTarget,
          vcomp: _ctx.v$.target
        }, null, 8, ["selectedTarget", "categories", "onValueChanged", "vcomp"]),
        _createVNode(_component_apply_target_card, {
          kpi: _ctx.kpi,
          onKpiChanged: _ctx.updateKpi,
          onShowDialog: _ctx.addKpiDialog
        }, null, 8, ["kpi", "onKpiChanged", "onShowDialog"])
      ])
    ]),
    _createVNode(_component_add_kpi_dialog, {
      kpi: _ctx.filteredKpi,
      dialogVisible: _ctx.kpiDialogVisible,
      loadingKpi: _ctx.loadingAllKpi,
      onClose: _ctx.closeKpiDialog,
      onAdd: _ctx.addKpi
    }, null, 8, ["kpi", "dialogVisible", "loadingKpi", "onClose", "onAdd"])
  ], 64))
}